import { useEffect } from "react";

import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";

import type { UserDTO } from "../../common/types/UserDTO";
import { useAppDispatch } from "../store/hooks";
import { updateFeatureFlag } from "../store/services/featureFlag/actions";
import type { FeatureFlagState } from "../store/services/featureFlag/types";
import toUserContext from "../utils/toUserContext";

const useLaunchDarkly = (userData: UserDTO | undefined) => {
  const ldClient = useLDClient();
  const flags = useFlags<FeatureFlagState>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      updateFeatureFlag({
        ...flags,
      }),
    );
  }, [flags]);

  if (!ldClient) return {};

  useEffect(() => {
    const updateLaunchDarklyContext = async () => {
      await ldClient.identify(toUserContext(userData));
    };

    void updateLaunchDarklyContext();
  }, [userData]);

  return { flags };
};

export default useLaunchDarkly;
